<!--
 某个地块的种植计划详细，按阶段树形显示
-->
<template>
  <div>
<!--    <el-empty v-show="total==0" description="暂无数据"></el-empty>-->
    <div v-if="activeTab">
      <el-steps direction="vertical" :active="1">
        <el-step
          v-for="(item,index) in stageList"
          :key="index"
          :title="`阶段${index+1}`"
        >
          <template slot="description">
            <div style="display: flex;flex-wrap: wrap">
              <el-card style="width: 20%" v-for="(ite,inde) in item" :key="inde">
                <p>日期:{{new Date(ite.begin).format('yyyy-MM-dd')}}</p>
                <p>专家建议:{{ite.content}}</p>
              </el-card>
            </div>
          </template>
          <span></span>
        </el-step>
      </el-steps>
<!--      <el-divider v-if="total>0" content-position="center">-->
<!--        <el-button v-if="count<total" type="primary" @click="more">加载更多</el-button>-->
<!--        <span v-else style="color: gray">已经到底了</span>-->
<!--      </el-divider>-->
    </div>
  </div>
</template>
<script>
  import { getPhasesOfPlan, getSuggestsOfPlan } from '@/api/plan2.js'
export default {
  name: 'PlanDetailTree',
  data() {
    return {
      planId:undefined,
      stageList:[],
      phase:[],
      suggests:[],
      activeTab:false
    }
  },
  mounted() {
    console.log('阶段整合',this.suggests,this.phase)
  },
  methods:{
    init(id) {
      this.planId=id
      if (id) {
        // 请求种植计划的阶段phases
        // 请求种植计划的阶段phases
        getPhasesOfPlan(id).then((resp) => {
          this.phase=resp.data
        }).then(()=>{
          getSuggestsOfPlan(id).then((resp) => {
            this.suggests=resp.data
          }).then(()=>{
            this.stage()
          })
        })
      }
    },
    stage() {

      let num =0
      for(let i=0;i<this.suggests.length;i++) {
        if(i==0){
          this.stageList[num]=[]
        }
        if(this.suggests[i].begin>=this.phase[num].begin&&this.suggests[i].begin<this.phase[num].end) {

          this.stageList[num].push(this.suggests[i])
        }else{
          num++;
          this.stageList[num]=[]
          this.stageList[num].push(this.suggests[i])
        }
      }
      this.activeTab=true
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/product/plan/PlanDetailTree.vue